module.exports = __webpack_public_path__ + "5bf1805202cdd4899b99c466d88c2a05.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/facebook.png
 ** module id = 1547
 ** module chunks = 0
 **/